import React from "react";
import { Link } from "react-router-dom";
import { getFullImageUrl } from "../services/api";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

// Import images from assets
import Banner1 from "../assets/banner/Nike Dunk Low White Fire Red Black.png";
import Banner2 from "../assets/banner/Nike Dunk Low Year Of The Dragon Best Quality.png";
import Banner3 from "../assets/banner/Nike Dunk Low CNY Pegasus ''Neutral Olive'.png";
import BannerKM from "../assets/banner/banner km.png";

const BannerSlider = ({ slides: dynamicSlides }) => {
  const fallbackSlides = [
    {
      img: Banner1,
      subtitle: "NIKE DUNK LOW",
      title: "WHITE FIRE RED",
      highlight: "NĂNG LƯỢNG STREET HUYỀN THOẠI",
      description:
        "Bước vào thế giới sneaker vượt thời gian. Thiết kế tương phản mạnh mẽ, êm ái huyền thoại và dễ phối đồ mỗi ngày.",
      buttonText: "MUA NGAY",
      productLink: "/product/69ad468c0b165b5100b67cbc",
      hasContent: true,
      objectPosition: "center",
    },
    {
      img: Banner2,
      subtitle: "NIKE DUNK LOW",
      title: "YEAR OF THE DRAGON",
      highlight: "CHẤT LƯỢNG CAO CẤP",
      description:
        "Tôn vinh sức mạnh của Rồng với thiết kế nổi bật và cảm giác mang êm ái. Một đôi sneaker huyền thoại dành cho phong cách street đích thực.",
      buttonText: "MUA NGAY",
      productLink: "/product/69ad3de20b165b5100b67cb2",
      hasContent: true,
      objectPosition: "center right",
    },
    {
      img: Banner3,
      subtitle: "NIKE DUNK LOW",
      title: "CNY PEGASUS",
      highlight: "NEUTRAL OLIVE",
      description:
        "Lấy cảm hứng từ tinh thần Pegasus mạnh mẽ. Phong cách nổi bật, chất liệu cao cấp và sự thoải mái cho từng bước chân.",
      buttonText: "MUA NGAY",
      productLink: "/product/69ad2fcdcaa40823fb8054b5",
      hasContent: true,
      objectPosition: "center",
    },
    {
      img: BannerKM,
      hasContent: false,
      objectPosition: "center",
      isPromo: true,
    },
  ];

  // Map dynamic backend data to slider format
  const slides = dynamicSlides && dynamicSlides.length > 0 
    ? dynamicSlides.map(s => ({
        img: getFullImageUrl(s.image),
        subtitle: s.subtitle,
        title: s.title,
        highlight: s.highlight,
        description: s.description,
        buttonText: s.buttonText || "MUA NGAY",
        productLink: s.link,
        hasContent: !!(s.title || s.subtitle),
        objectPosition: s.theme || "center", // We'll use theme field for position for now
        isPromo: !s.title && !s.subtitle
      }))
    : fallbackSlides;

  return (
    <div className="w-full relative mt-16 xl:mt-20">
      <Swiper
        modules={[Autoplay, Pagination, Navigation, EffectFade]}
        effect="fade"
        loop={true}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        navigation={true}
        className="w-full h-[220px] sm:h-[400px] md:h-[500px] lg:h-[600px] xl:h-[700px]"
      >
        {slides.map((slide, i) => (
          <SwiperSlide key={i}>
            <div
              className={`relative w-full h-full overflow-hidden ${slide.isPromo ? "bg-blue-900" : ""}`}
            >
              <img
                src={slide.img}
                alt={`banner-${i}`}
                className={`w-full h-full ${slide.isPromo ? "object-contain" : "object-cover"}`}
                style={{ objectPosition: slide.objectPosition || "center" }}
              />

              {slide.hasContent && (
                <div className="absolute inset-0 bg-gradient-to-t sm:bg-gradient-to-r from-black/80 via-black/40 sm:via-black/20 to-transparent flex items-end sm:items-center pb-4 sm:pb-0">
                  <div className="max-w-7xl mx-auto px-6 sm:px-10 md:px-20 w-full">
                    <div className="max-w-xl text-white space-y-1.5 sm:space-y-4 animate-in fade-in slide-in-from-bottom-5 sm:slide-in-from-left-10 duration-1000">
                      <p className="text-blue-400 font-black tracking-[0.2em] text-[10px] sm:text-base uppercase">
                        {slide.subtitle}
                      </p>
                      <h2 className="text-xl sm:text-4xl md:text-6xl font-black leading-[1.1] tracking-tighter sm:tracking-normal">
                        {slide.title}
                      </h2>
                      <div className="inline-block bg-white/10 backdrop-blur-md px-3 py-0.5 sm:px-4 sm:py-1 rounded border border-white/20">
                        <p className="text-[10px] sm:text-lg font-bold tracking-wider text-gray-100">
                          {slide.highlight}
                        </p>
                      </div>
                      <p className="text-sm md:text-lg text-gray-200 max-w-lg hidden sm:block leading-relaxed">
                        {slide.description}
                      </p>
                      <div className="pt-2 sm:pt-4">
                        <Link to={slide.productLink || "#"}>
                          <button className="bg-white text-black px-5 py-2 sm:px-8 sm:py-3 rounded-full font-black text-xs sm:text-base hover:bg-blue-600 hover:text-white transition-all duration-300 transform active:scale-95 shadow-xl">
                            {slide.buttonText}
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <style>{`
        .swiper-button-next,
        .swiper-button-prev {
          color: white !important;
          background: rgba(255, 255, 255, 0.1);
          width: 50px !important;
          height: 50px !important;
          border-radius: 50%;
          backdrop-filter: blur(4px);
          transition: all 0.3s ease;
        }
        .swiper-button-next:after,
        .swiper-button-prev:after {
          font-size: 20px !important;
          font-weight: bold;
        }
        .swiper-button-next:hover,
        .swiper-button-prev:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: scale(1.1);
        }
        .swiper-pagination-bullet {
          background: white !important;
          opacity: 0.5;
          width: 8px;
          height: 8px;
          transition: all 0.3s ease;
        }
        .swiper-pagination-bullet-active {
          opacity: 1;
          width: 20px;
          border-radius: 5px;
          background: #3b82f6 !important;
        }
        @media (max-width: 640px) {
          .swiper-button-next,
          .swiper-button-prev {
            display: none !important;
          }
          .swiper-pagination-bullet {
            width: 6px;
            height: 6px;
          }
          .swiper-pagination-bullet-active {
            width: 15px;
          }
        }
      `}</style>
    </div>
  );
};

export default BannerSlider;
